import { Component, ReactNode } from 'react'

interface Props { children: ReactNode }
interface State { error: Error | null; info: string | null }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null, info: null }

  static getDerivedStateFromError(error: Error): State {
    return { error, info: null }
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    console.error('[ErrorBoundary]', error)
    console.error('[ErrorBoundary stack]', info.componentStack)
    this.setState({ error, info: info.componentStack })
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: '100vh',
          background: '#0a0a0b',
          color: '#fff',
          padding: '40px',
          fontFamily: 'monospace',
          fontSize: '13px',
          overflow: 'auto',
        }}>
          <h2 style={{ color: '#ff6b6b', marginBottom: '16px' }}>
            Something broke. Diagnostic info below.
          </h2>
          <div style={{ marginBottom: '12px' }}>
            <strong>Error:</strong> {this.state.error.message}
          </div>
          <div style={{ marginBottom: '12px' }}>
            <strong>Stack:</strong>
            <pre style={{ whiteSpace: 'pre-wrap', color: '#aaa' }}>
              {this.state.error.stack}
            </pre>
          </div>
          <div>
            <strong>Component stack:</strong>
            <pre style={{ whiteSpace: 'pre-wrap', color: '#aaa' }}>
              {this.state.info}
            </pre>
          </div>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              background: '#6c52e8',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
            }}
          >
            Back to landing
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
